import React from "react";

const FloContext = React.createContext({});
FloContext.displayName = 'FloContext';

export default FloContext;
